import Vue       from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import QuestionsView           from '@/views/QuestionsView.vue';
import PhoneAppointmentView    from '@/views/PhoneAppointmentView.vue';
import OnlineAppointmentView   from '@/views/OnlineAppointmentView.vue';
import ChooseDayView           from '@/views/OnlineAppointment/ChooseDayView';
import ChooseTimeSlotView
                               from '@/views/OnlineAppointment/ChooseTimeSlotView';
import ThankYouView            from '@/views/OnlineAppointment/ThankYouView';
import ChooseLocationView
                               from '@/views/OnlineAppointment/ChooseLocationView';
import ChooseAppointmentTypeView
                               from '@/views/OnlineAppointment/ChooseAppointmentTypeView';
import VisitorDataView         from '@/views/OnlineAppointment/VisitorDataView';
import PhoneAppointmentThankYouView
                               from '@/views/PhoneAppointment/PhoneAppointmentThankYouView';
import AppointmentCanceledView from '@/views/AppointmentCanceledView';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: QuestionsView,
  },
  {
    path: '/phone-appointment',
    name: 'PhoneContact',
    component: PhoneAppointmentView,
  },
  {
    path: '/phone-appointment/thank-you',
    name: 'PhoneContact Thank You',
    component: PhoneAppointmentThankYouView,
  },
  {
    path: '/online-appointment',   
    component: OnlineAppointmentView,
    children: [
      {
        path: '',
        name: 'OnlineAppointment',
        component: ChooseLocationView,
      },
      {
        path: ':locationId',
        component: ChooseAppointmentTypeView,
        props: true,
      },
      {
        path: ':locationId/:appointmentTypeId',
        component: ChooseDayView,
        props: true,
      },
      {
        path: ':locationId/:appointmentTypeId/:date',
        component: ChooseTimeSlotView,
        props: true,
      },
      {
        path: ':locationId/:appointmentTypeId/:date/visitor-data',
        component: VisitorDataView,
        props: true,
      },
      {
        path: ':locationId/:appointmentTypeId/:appointmentId/thank-you',
        component: ThankYouView,
        props: true,
      },
    ],
  },
  {
    path: '/cancel/:code',
    name: 'Appointment Canceled',
    component: AppointmentCanceledView,
    props: true,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
